import {createRouter, createWebHistory} from 'vue-router'
import LoginPage from '@/features/auth/screens/LoginPage.vue'
import MainPage from '@/core/components/MainPage.vue'
import {userAPI} from '@/features/user/api/user';
import {ref} from "vue";

export const user = ref({});


const routes = [
    {
        path: '/',
        redirect: 'login',
        children: [
            {
                path: 'login',
                name: 'Login',
                component: LoginPage
            },
            {
                path: 'register',
                name: 'RegisterPage',
                component: () => import('@/features/auth/screens/RegisterPage.vue')
            },
            {
                path: 'totp-enrollment',
                name: 'TotpEnrollment',
                component: () => import('@/features/auth/screens/TotpEnrollmentPage.vue')
            },
            {
                path: 'main',
                name: 'MainPage',
                component: MainPage,
                redirect: {name: 'HomePage'},
                children: [
                    {
                        path: '',
                        name: 'HomePage',
                        component: () => import('@/features/home/screens/HomePage.vue'),
                        meta: {title: '主页', icon: 'HomeFilled', roles: [0, 1, 2]}
                    },
                    {
                        path: 'prd',
                        name: 'prdPage',
                        component: () => import('@/features/prd/screens/PrdPage.vue'),
                        meta: {title: '项目进程管理', icon: 'Flag', roles: [0, 1, 2]}
                    },
                    {
                        path: 'user',
                        name: 'UserPage',
                        component: () => import('@/features/user/screens/UserPage.vue'),
                        meta: {title: '用户管理', icon: 'User', roles: [0]}
                    },
                    {
                        // OJ 账号绑定引导页，不进左侧菜单（无 meta.title），需登录态
                        path: 'oj-binding',
                        name: 'OjBindingPage',
                        component: () => import('@/features/home/components/OjBindingGuide.vue'),
                        meta: {roles: [0, 1, 2, 3]}
                    },
                    {
                        path: 'dict',
                        name: 'DictPage',
                        component: () => import('@/features/dict/screens/DictPage.vue'),
                        meta: {title: '字典管理', icon: 'Notebook', roles: [0]}
                    },
                    {
                        path: 'AwardPage',
                        name: 'AwardPage',
                        component: () => import('@/features/award/screens/AwardPage.vue'),
                        meta: {title: '奖项管理', icon: 'Lock', roles: [0]}
                    },
                    {
                        path: 'SchedulePage',
                        name: 'SchedulePage',
                        component: () => import('@/features/schedule/screens/SchedulePage.vue'),
                        meta: {title: '调度系统', icon: 'AlarmClock', roles: [0]}
                    },
                    {
                        path: 'training',
                        name: 'TrainingPage',
                        component: () => import('@/features/training/screens/TrainingPage.vue'),
                        meta: {title: '训练管理', icon: 'TrophyBase', roles: [0, 1, 2]}
                    },
                    {
                        path: 'Administrator',
                        name: 'AdministratorPage',
                        component: () => import('@/features/user/screens/AdministratorVisible.vue'),
                        meta: {title: '仅管理员可见（测试）', icon: 'Lock', roles: [0]}
                    },
                    {
                        path: 'recruitment',
                        name: 'RecruitmentHome',
                        component: () => import('@/features/recruitment/screens/RecruitmentHome.vue'),
                        meta: {title: '招新航线', icon: 'Compass', roles: [3]}
                    },
                    {
                        path: 'recruitment/records',
                        name: 'RecruitmentRecords',
                        component: () => import('@/features/recruitment/screens/RecruitmentRecords.vue'),
                        meta: {title: '同届过题', icon: 'Collection', roles: [3], allowStudentCoach: true}
                    },
                    {
                        path: 'recruitment-admin',
                        name: 'RecruitmentAdmin',
                        component: () => import('@/features/recruitment/screens/RecruitmentAdmin.vue'),
                        meta: {title: '招新管理', icon: 'DataAnalysis', roles: [0], allowStudentCoach: true}
                    },

                    {
                path:'adventurers',
                name:'AdventurersPage',
                component: () => import('@/features/adventurers/screens/AdventurersPage.vue'),
                meta: { title: '冒险家协会', icon: 'AdventurerIcon', roles: [0, 1, 2] },
                children: [
                    {
                    path: 'home',
                    name: 'AdventurersHome',
                    component: () => import('@/features/adventurers/screens/HomePage.vue'),
                    },
                    {
                    path: 'tasks',
                    name: 'AdventurersTasks',
                    component: () => import('@/features/adventurers/screens/TasksPage.vue')

                    },
                    {
                    path: 'profile',
                    name: 'AdventurersProfile',
                    component: () => import('@/features/adventurers/screens/ProfilePage.vue')
                    },
                    {
                    path: 'team',
                name: 'AdventurersTeam',
                component: () => import('@/features/adventurers/screens/TeamPage.vue')
                },
                {
                path: 'admin',
                name: 'AdventurersAdmin',
                meta: { roles: [0] },
                component: () => import('@/features/adventurers/admin/AdminDashboard.vue'),
                redirect: '/main/adventurers/admin/dashboard',
                children: [
                    { path: 'dashboard', name: 'AdminDashboard', component: () => import('@/features/adventurers/admin/DashboardOverview.vue') },
                    { path: 'members', name: 'AdminMembers', component: () => import('@/features/adventurers/admin/MemberManagement.vue') },
                    { path: 'tasks', name: 'AdminTasks', component: () => import('@/features/adventurers/admin/TaskManagement.vue'), meta: { keepAlive: true } },
                    { path: 'teams', name: 'AdminTeams', component: () => import('@/features/adventurers/admin/TeamManagement.vue'), meta: { keepAlive: true } },
                    { path: 'statistics', name: 'AdminStatistics', component: () => import('@/features/adventurers/admin/AdminStatistics.vue'), meta: { keepAlive: true } }
                    ]
                    },
                    {
                    path: '',
                    name: 'AdventurersDefault',
                    redirect: '/main/adventurers/home'
                    }
                ]
            },
            ]
            }
        ]
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routes
})

let isUserInfoFetched = false;

/**
 * A route may be available to its declared roles or explicitly to a student
 * coach. Student coach is an independent capability and must not become a
 * synthetic roleId (in particular, never roleId=4).
 */
export const canAccessRoute = (record, currentUser = user.value) => {
    const roles = record?.meta?.roles;
    const currentRoleId = Number(currentUser?.roleId);
    const roleAllowed = !Array.isArray(roles) || roles.map(Number).includes(currentRoleId);
    const coachAllowed = record?.meta?.allowStudentCoach === true
        && currentUser?.studentCoach === true
        && [1, 2].includes(currentRoleId);
    return roleAllowed || coachAllowed;
};

router.beforeEach(async (to, from, next) => {
    const openRouteNames = ['Login', 'RegisterPage'];
    if (openRouteNames.includes(to.name)) {
        if (!localStorage.getItem("isLogin")) {
            isUserInfoFetched = false;
            user.value = {};
        }
        next();
        return;
    }

    const token = localStorage.getItem("isLogin");
    if (!token) {
        isUserInfoFetched = false;
        user.value = {};
        next({name: 'Login'});
        return;
    }

    if (!isUserInfoFetched) {
        try {
            const res = await userAPI.getUserInfo();
            if (!res.success || !res.data) throw new Error(res.msg || '无法获取用户信息');
            user.value = res.data;
            isUserInfoFetched = true;
        } catch (error) {
            console.error('获取登录用户信息失败', error);
            next({name: 'Login'});
            return;
        }
    }

    const roleId = Number(user.value.roleId);
    const deniedByRole = to.matched.some(record => !canAccessRoute(record));
    if (deniedByRole) {
        next({name: roleId === 3 ? 'RecruitmentHome' : 'HomePage'});
        return;
    }

    next();
});

export default router
